"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSummarySchema = exports.ResetPasswordResultSchema = exports.UpdateUserRequestSchema = exports.CreateUserRequestSchema = exports.ChangePasswordRequestSchema = exports.AuthUserSchema = exports.LoginRequestSchema = exports.RoleSchema = void 0;
const zod_1 = require("zod");
/**
 * Xác thực — bốn vai trò theo PRS §2.
 *
 * Copilot là ứng dụng độc lập nên tự quản đăng nhập; đăng nhập bằng Google là
 * provider thêm sau, không thay thế cái này.
 * Xem `docs/change-request-san-pham-doc-lap_20260807.md` §6.
 */
exports.RoleSchema = zod_1.z.enum([
    'MARKETING_EXECUTIVE',
    'CONTENT_EDITOR',
    'WEB_ADMINISTRATOR',
    'PRODUCT_MARKETING_LEAD',
]);
exports.LoginRequestSchema = zod_1.z.object({
    email: zod_1.z.string().trim().toLowerCase().email('Email không hợp lệ'),
    password: zod_1.z.string().min(1, 'Chưa nhập mật khẩu'),
});
/**
 * Thông tin người đăng nhập trả về cho giao diện.
 * KHÔNG chứa mật khẩu băm, cũng không chứa token — token nằm trong cookie
 * httpOnly nên JavaScript của trang không cần và không được đọc.
 */
exports.AuthUserSchema = zod_1.z.object({
    id: zod_1.z.number().int().positive(),
    email: zod_1.z.string().email(),
    name: zod_1.z.string(),
    role: exports.RoleSchema,
    /**
     * Đang dùng mật khẩu TẠM do quản trị đặt hộ — spec SC-09-C.
     * Giao diện phải đưa thẳng người dùng tới màn đổi mật khẩu và không cho vào màn
     * nào khác; API cũng chặn ở tầng của nó, không tin mỗi giao diện.
     */
    mustChangePassword: zod_1.z.boolean().default(false),
});
/**
 * Độ dài mật khẩu tối thiểu.
 *
 * 10 ký tự thay vì 8: đây là công cụ nội bộ nhưng đặt trên tên miền công khai, và
 * hiện chưa có cơ chế khoá tài khoản sau nhiều lần đăng nhập sai.
 */
const MIN_PASSWORD = 10;
const passwordField = zod_1.z
    .string()
    .min(MIN_PASSWORD, `Mật khẩu phải từ ${MIN_PASSWORD} ký tự`)
    .max(200, 'Mật khẩu quá dài');
/** Người dùng tự đổi mật khẩu — phải nhập mật khẩu hiện tại. */
exports.ChangePasswordRequestSchema = zod_1.z
    .object({
    currentPassword: zod_1.z.string().min(1, 'Chưa nhập mật khẩu hiện tại'),
    newPassword: passwordField,
})
    .refine((v) => v.currentPassword !== v.newPassword, {
    message: 'Mật khẩu mới phải khác mật khẩu hiện tại',
    path: ['newPassword'],
});
/** Web Administrator tạo tài khoản mới. */
exports.CreateUserRequestSchema = zod_1.z.object({
    email: zod_1.z.string().trim().toLowerCase().email('Email không hợp lệ'),
    name: zod_1.z.string().trim().min(1, 'Chưa nhập tên').max(80),
    role: exports.RoleSchema,
    password: passwordField,
});
/** Sửa tài khoản. Không đổi email ở đây — email là danh tính, đổi thì tạo mới. */
exports.UpdateUserRequestSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1).max(80).optional(),
    role: exports.RoleSchema.optional(),
    active: zod_1.z.boolean().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'Không có gì để sửa' });
/**
 * Admin đặt lại mật khẩu hộ — spec SC-09-C bước 1.
 *
 * KHÔNG nhận mật khẩu do admin tự nghĩ nữa: hệ thống sinh một mật khẩu tạm ngẫu
 * nhiên, hiện đúng một lần cho admin đọc lại cho người dùng. Như vậy không có
 * chuyện đặt cùng một mật khẩu cho mọi người, và admin không biết mật khẩu lâu
 * dài của ai — người dùng bị bắt đổi ngay ở lần đăng nhập kế tiếp.
 */
exports.ResetPasswordResultSchema = zod_1.z.object({
    /** Hiện MỘT LẦN. Tải lại trang là không xem lại được. */
    tempPassword: zod_1.z.string(),
    expiresAt: zod_1.z.coerce.date(),
});
/** Một dòng trong màn quản lý người dùng. */
exports.UserSummarySchema = exports.AuthUserSchema.extend({
    active: zod_1.z.boolean(),
    createdAt: zod_1.z.coerce.date(),
    /** false với người chỉ đăng nhập bằng Google (sau này) hoặc chưa đặt mật khẩu. */
    hasPassword: zod_1.z.boolean(),
});
//# sourceMappingURL=auth.js.map